import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { AnalyticsModule } from '../analytics/analytics.module'
import { EventAddToCalendarComponent } from './event-add-to-calendar.component'
import { OldSvgModule } from 'src/app/libs/_deprecated/svg/old-svg.module'

@NgModule({
  imports: [CommonModule, OldSvgModule, AnalyticsModule],
  declarations: [EventAddToCalendarComponent],
  providers: [],
  exports: [EventAddToCalendarComponent]
})
export class EventAddToCalendarModule {}
